import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import getters from './getters'
import loading from './modules/loading'
import history from './modules/history'
import dictData from './modules/dict'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    loading,
    history,
    dictData
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js